var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "700px",
        fullscreen: _vm.$vuetify.breakpoint.xsOnly
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _c(
                  "v-card",
                  {
                    staticClass: "d-flex flex-column",
                    attrs: { "min-height": "100%" }
                  },
                  [
                    _c("v-card-title", { staticStyle: { height: "64px" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("import_products")) + " ")
                    ]),
                    _c(
                      "v-card-text",
                      { staticClass: "flex-grow-1" },
                      [
                        _c(
                          "v-form",
                          [
                            _c(
                              "v-container",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c("v-col", [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("folder")) + " "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.directory.name))
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: _vm.$t("file")
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-file-input", {
                                                      attrs: {
                                                        label: _vm.$t("file"),
                                                        accept: ".xlsx",
                                                        "show-size": "",
                                                        outlined: "",
                                                        dense: "",
                                                        disabled: _vm.loading,
                                                        "error-messages": errors,
                                                        "hide-details":
                                                          errors.length === 0
                                                      },
                                                      model: {
                                                        value: _vm.file,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.file = $$v
                                                        },
                                                        expression: "file"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.warnings && _vm.warnings.length > 0
                          ? _c(
                              "v-alert",
                              {
                                attrs: {
                                  border: "bottom",
                                  "colored-border": "",
                                  type: "warning",
                                  elevation: "2",
                                  dismissible: ""
                                }
                              },
                              [
                                _c(
                                  "ul",
                                  _vm._l(_vm.warnings, function(warning, idx) {
                                    return _c("li", { key: idx }, [
                                      _vm._v(" " + _vm._s(warning) + " ")
                                    ])
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "px-7 pb-5" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary--text",
                            attrs: { text: "" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loading,
                              disabled: !valid,
                              depressed: "",
                              color: "primary"
                            },
                            on: { click: _vm.confirm }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("import")) + " ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }